import React from 'react';
import { Layout, Progress, Modal, Checkbox, Badge } from 'antd';
import Icon from 'components/Icon';
import Popover from 'components/Popover';
import $$ from 'cmn-utils';
import { Img } from 'components/Material';
import { materialExtFilters, materialMaxSize_ispackage, materialMaxSize_dsyun, picExtFilters, videoExtFilters, musicExtFilters, wordExtFilters, excelExtFilters, pptExtFilters, pdfExtFilters, sysExtFilters, upgradeFileExtFilters } from '@/utils/common/constants';
import { qryAuthClientNumsClientFlowDiskSpaceByUser } from '@/routes/System/Org/service';
import './upload.less';
import config from '@/config';

const notice = config.notice;
const { Sider } = Layout;
let autoUploadTimeOut;
let username;
let materialMaxSize;
let isPackage = $$.getStore("isPackage");
let fileSizeLimitTip = window.language['material.fileSizeLimit'];
if (isPackage === "undefined") {
    materialMaxSize = materialMaxSize_dsyun;
} else {
    materialMaxSize = materialMaxSize_ispackage;
    fileSizeLimitTip = fileSizeLimitTip.replace('M', 'G');
}

export default class UploadPanel extends React.Component {
    constructor(props) {
        super(props);
        username = $$.getStore("user").username;
        this.state = {
            file: [],
            uploading: false,
            fileList: [],
            fileCount: { pictureCount: 0, videoCount: 0, musicCount: 0, wordCount: 0, excelCount: 0, pdfCount: 0, pptCount: 0, sysCount: 0 },
            uploadBtnStatus: true,//上传按钮状态
            stopBtnStatus: true,//停止按钮状态
            removeBtnStatus: false,//删除按钮状态
            uploadingStatus: false,
            folderId: props.folderId ? props.folderId : '',
            isAuditAuth: '1',
            advertiserId: '',
            apkId: '',
            isAuto: $$.getStore(`${username}_IsAutoUpload`) === null ? true : $$.getStore(`${username}_IsAutoUpload`),
            isUploadFlag: true,
            leftDiskSapce: 0
        };
        this._t = {}
    }

    componentWillMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidMount() {
        let authCodes = $$.getStore('authCodes');//按钮权限代码列表
        this.props.panelObj.uploadModelClose = this.uploadModelClose;
        let thiz = this;
        const target = config.request.prefix;
        //let userToken = $$.getStore('token');
        let userToken = window.sessionStorage.getItem('token');
        let extFilters = [];
        let type = this.props.type;
        if (type && type.length > 0) {
            for (let t of type) {
                if (t === '1' && authCodes["MATERIAL.PICTURE.UPLOAD"]) {
                    extFilters = [...extFilters, ...picExtFilters];
                } else if (t === '0' && authCodes["MATERIAL.VIDEO.UPLOAD"]) {
                    extFilters = [...extFilters, ...videoExtFilters];
                } else if (t === '2' && authCodes["MATERIAL.MUSIC.UPLOAD"]) {
                    extFilters = [...extFilters, ...musicExtFilters];
                } else if (t === '15' && authCodes["MATERIAL.DOC.UPLOAD"]) {
                    extFilters = [...extFilters, ...wordExtFilters];
                } else if (t === '16' && authCodes["MATERIAL.XLS.UPLOAD"]) {
                    extFilters = [...extFilters, ...excelExtFilters];
                } else if (t === '17' && authCodes["MATERIAL.PPT.UPLOAD"]) {
                    extFilters = [...extFilters, ...pptExtFilters];
                } else if (t === '35' && authCodes["MATERIAL.PDF.UPLOAD"]) {
                    extFilters = [...extFilters, ...pdfExtFilters];
                } else if (t === '10' && authCodes["SYSTEM.SYSFILE.UPLOADFILE"]) {
                    extFilters = [...extFilters, ...sysExtFilters];//终端升级
                } else if (t === '19' && authCodes["SYSTEM.SYSFILE.UPLOADFILE"]) {
                    extFilters = [...extFilters, ...excelExtFilters];
                } else if (t === '20' && authCodes["SYSTEM.UPGRADEFILE.UPLOADFILE"]) {
                    extFilters = [...extFilters, ...upgradeFileExtFilters];//升级文件
                }
            }
        } else {
            extFilters = materialExtFilters;
        }

        //console.log('extFilters', extFilters);


        let { isSys } = thiz.props;
        let simLimitSize = 100; // 同时上传文件数量
        let uploadConfig = {
            enabled: true,
            /** 是否启用文件选择，默认是true */
            customered: true,
            /** 是否是自定义UI，默认是false */
            multipleFiles: true,
            /** 是否允许同时选择多个文件，默认是false */
            autoRemoveCompleted: false,
            /** 是否自动移除已经上传完毕的文件，非自定义UI有效(customered:false)，默认是false */
            autoUploading: false,
            /** 当选择完文件是否自动上传，默认是true */
            retryCount: 1,
            /** HTML5上传失败的重试次数 */
            fileFieldName: "FileData",
            extFilters: extFilters,
            /** 默认是全部允许，即 [] */
            maxSize: materialMaxSize,
            /** 允许同时选择文件上传的个数（包含已经上传过的） */
            browseFileId: "i_select_files",
            /** 文件选择的Dom Id，如果不指定，默认是i_select_files */
            browseFileBtn: " ",
            /** 选择文件的按钮内容，非自定义UI有效(customered:false) */
            dragAndDropArea: "i_stream_dropzone",
            dragAndDropTips: " ",
            filesQueueId: "i_stream_files_queue",
            /** 文件上传进度显示框ID，非自定义UI有效(customered:false) */
            filesQueueHeight: 450,
            /** 文件上传进度显示框的高，非自定义UI有效(customered:false)，默认450px */
            messagerId: "i_stream_message_container",
            /** 消息框的Id，当没有自定义onXXX函数，系统会显示onXXX的部分提示信息，如果没有i_stream_message_container则不显示 */
            swfURL: "%PUBLIC_URL%/stream/swf/FlashUploader.swf",
            /** SWF文件的位置 */
            tokenURL: `${target}/tk`,
            /** 根据文件名、大小等信息获取Token的URI（用于生成断点续传、跨域的令牌） */
            frmUploadURL: "fdUpload",
            /** Flash上传的URI */
            //uploadURL: "upload",
            uploadURL: `${target}/upload`,
            postVarsPerFile: {
                /** 上传文件时传入的参数，默认: {} */
                userToken: userToken,
                folderId: thiz.state.folderId,
                advertiserId: thiz.state.advertiserId,
                apkId: thiz.state.apkId,
                isSys: isSys,
                isAuditAuth: thiz.state.isAuditAuth,
                uploadFromType: this.props.currentType,
            },
            onSelect: function (files) {
                //thiz.changeBtnStatus('uploadBtnStatus', false, false);
                let fileList = thiz.state.fileList;
                let newFile = [];
                // 不符合上传要求的移除掉
                for (let f of files) {
                    let name = f.name;
                    if (name) {
                        let suffix = name.substring(name.lastIndexOf("."), name.length).toLowerCase();
                        let index = extFilters.indexOf(suffix);
                        // 不包含改元素
                        if (index !== -1) {
                            newFile.push(f);
                        }
                    }
                }

                fileList = fileList.concat(newFile.map((item) => {
                    item.key = item.id;
                    item.state = -1;
                    let size = item.size;
                    // 如果小于0.1KB转化成B  
                    if (size < 0.1 * 1024) {
                        size = size.toFixed(2) + "B";
                    } else if (size < 0.1 * 1024 * 1024) { // 如果小于0.1MB转化成KB  
                        size = (size / 1024).toFixed(2) + "KB";
                    } else if (size < 0.1 * 1024 * 1024 * 1024) { // 如果小于0.1GB转化成MB  
                        size = (size / (1024 * 1024)).toFixed(2) + "MB";
                    } else { // 其他转化成GB  
                        size = (size / (1024 * 1024 * 1024)).toFixed(2) + "GB";
                    }
                    item.showSize = size;
                    return item;
                }));

                if (fileList.length > simLimitSize) {
                    let limit = window.language['material.fileNumberLimit'];
                    Modal.warning({
                        title: window.language['material.notice'],
                        className: 'custom-modal',
                        content: limit.replace("{0}", simLimitSize),
                        okText: window.language["common.ok"],
                        onOk() { }
                    });
                    fileList = fileList.slice(0, simLimitSize);
                }
                if (fileList.length > 0) {
                    thiz.changeBtnStatus('uploadBtnStatus', false, false);
                    if (thiz.state.isAuto) {
                        autoUploadTimeOut = setTimeout(() => {
                            if (thiz._isMounted) {
                                thiz.setState({
                                    uploadingStatus: true,
                                    stopBtnStatus: false,
                                });
                            }

                            // thiz._t.upload();
                            thiz.upload();
                        }, 3000);
                    }
                }
                thiz.setState({
                    fileList: fileList
                });
            },
            onExtNameMismatch: function (file) {
                if (thiz._t.waiting.length === 0) {
                    thiz.changeBtnStatus('uploadBtnStatus', false, true);
                } else {
                    thiz.changeBtnStatus('uploadBtnStatus', false, false);
                }

                Modal.warning({
                    title: window.language['material.notice'],
                    className: 'custom-modal',
                    content: file.name + window.language['material.filenameNotMatch'],
                    okText: window.language["common.ok"],
                    onOk() { }
                });
            },
            onMaxSizeExceed: function (file) {
                console.log('materialMaxSize', materialMaxSize);
                console.log('fileSize', file.size);
                if (thiz._t.waiting.length === 0) {
                    thiz.changeBtnStatus('uploadBtnStatus', false, true);
                } else {
                    thiz.changeBtnStatus('uploadBtnStatus', false, false);
                }
                Modal.warning({
                    title: window.language['material.notice'],
                    className: 'custom-modal',
                    content: fileSizeLimitTip,
                    okText: window.language["common.ok"],
                    onOk() { }
                });
            },
            onAddTask: function (file, dat) {
                // console.log(thiz.state.fileList.length)
                // if (thiz.state.fileList.length >= simLimitSize) {
                //     Modal.warning({
                //          title: window.language['material.notice'],
                //          className: 'custom-modal',
                //          content: window.language['material.filenameNotMatch'],
                //          okText: window.language["common.ok"],
                //          onOk() {}
                //     });
                //     return;
                // }
                // if (thiz.state.fileList.length >= 0) {
                //     thiz.changeBtnStatus('uploadBtnStatus', false, false);
                // }

                // file.key = file.id;
                // file.state = -1;

                // thiz.setState({
                //     fileList: [...thiz.state.fileList, file]
                // })
            },
            onUploadProgress: function (file) {
                if (file.percent > 99) {
                    thiz.changeBtnStatus('stopBtnStatus', false, true);
                } else {
                    thiz.changeBtnStatus('stopBtnStatus', false, false);
                }

                // 上传进度条
                thiz.setState({
                    fileList: thiz.state.fileList.map((item) => {
                        if (file.id === item.id) {
                            item.percent = file.percent;
                            item.formatSpeed = file.formatSpeed;
                            item.state = -2;
                        }
                        return item;
                    })
                });

            },
            onStop: function () {
                thiz._t.enable();
                thiz.changeBtnStatus('', true, false);
            },
            onCancel: function (file) {
            },
            onCancelAll: function (numbers) {
                thiz.changeBtnStatus('uploadBtnStatus', false, true);
            },
            onComplete: function (file) {
                // 单个文件上传完成
                // 上传进度条
                let fileCount = thiz.setMaterialCount(file.name);
                thiz.setState({
                    fileList: thiz.state.fileList.map((item) => {
                        if (file.id === item.id) {
                            item.percent = file.percent;
                            item.state = -4;
                        }
                        return item;
                    }),
                    fileCount,
                });

                setTimeout(() => {
                    if (thiz._isMounted) {
                        thiz.setState({
                            fileList: thiz.state.fileList.filter((item) => item.id !== file.id)
                        });
                    }
                }, 2000);
            },
            onQueueComplete: function (msg) {
                //更新用户磁盘空间
                // let { fileSize } = thiz.state;
                // let loginUser = $$.getStore("user");
                // let org = loginUser.org;
                // if (parseInt(org.level) > 2) {
                //     let payload = {
                //         usedDiskSpace: fileSize
                //     }
                //     updateAuthClientNumsClientFlowDiskSpaceByUser(payload).then(
                //     ).catch();
                // }

                // 所有文件上传完成
                thiz.changeBtnStatus('', true, false);
                thiz.setState({
                    uploadingStatus: false,
                });
                thiz._t.enable();
                thiz._t.cancel();

                let callBack = thiz.props.callBack;
                if (typeof (callBack) === "function") {
                    callBack();
                } else if (typeof (callBack) === "string") {
                    eval(callBack);
                }
            },
            onUploadError: function (status, msg) {
                thiz.afterError(status, JSON.parse(msg));
            }
        };
        this._t = new window.Stream(uploadConfig);
    }

    changeBtnStatus = (btn, isAll, status) => {
        if (isAll) {
            this.setState({
                uploadBtnStatus: status,
                stopBtnStatus: !status,
                removeBtnStatus: status,
            });
        } else {
            this.setState({
                [btn]: status,
            });
        }
    }

    remove = (file) => {
        Modal.confirm({
            title: window.language['common.del'],
            okText: window.language['common.ok'],
            cancelText: window.language['common.cancel'],
            className: 'custom-modal',
            content: window.language['common.delTipContent2'],
            onOk: () => {
                this.removeMethod(file);
            },
            onCancel() { },
        });
    }

    removeMethod = (file) => {
        if (file) {
            const fileList = [...this.state.fileList];
            if (this._t.uploadInfo[file.key]) {
                try {
                    this._t.cancelOne(file.key);
                } catch (e) {
                    // console.log(e);
                }
            }
            this.setState({
                fileList: fileList.filter(item => item.key !== file.key)
            }, () => {
                if (this.state.fileList.length === 0) {
                    this._t.enable();
                    this.setState({
                        uploadBtnStatus: true,
                        stopBtnStatus: true,
                        uploadingStatus: false,
                    });
                } else if (this.state.uploadingStatus === false) {//不在上传中
                    this.stop();

                }
            });
        } else {
            try {
                this._t.enable();
                this._t.cancel();
            } catch (e) {
                console.error(e);
            }
            this.setState({
                fileList: []
            }, () => {
                if (this.state.fileList.length === 0) {
                    this.setState({
                        uploadBtnStatus: true,
                        stopBtnStatus: true,
                        uploadingStatus: false,
                    })
                }
            });
        }
    }

    upload = () => {
        this.changeBtnStatus('uploadBtnStatus', false, true);
        try {
            clearTimeout(autoUploadTimeOut);

            if (this._isMounted) {
                this.setState({
                    stopBtnStatus: false,
                    uploadingStatus: true,
                });
            }

            this._t.disable();
            this._t.stop();
            this._t.upload();
        } catch (e) {
            console.error(e);
        }
        // qryAuthClientNumsClientFlowDiskSpaceByUser().then(
        //     ({ code, root }) => {
        //         if (code === "200") {
        //             const fileList = [...this.state.fileList];
        //             let totalSize = 0;
        //             fileList.forEach((item) => {
        //                 let fileSize = item.size;
        //                 totalSize += fileSize;
        //             });
        //             let { assignDiskSpace, usedDiskSpace, buyDiskSpace, usedBuyDiskSpace } = root;
        //             let level = $$.getStore("user").org.level;
        //             if (level !== "1") {
        //                 this.setState({
        //                     leftDiskSapce: (assignDiskSpace + buyDiskSpace) - (usedDiskSpace + usedBuyDiskSpace)
        //                 });

        //                 //会对比剩余空间，如果待上传总大小小于剩余空间，就可以上传，否则不给上传
        //                 if (((assignDiskSpace +  buyDiskSpace)- (usedDiskSpace + usedBuyDiskSpace)) < totalSize) {
        //                     notice.error(window.language['material.upload.maxSpaceLimit']);

        //                     this.stop();//上传终止

        //                     return;
        //                 }

        //                 try {
        //                     clearTimeout(autoUploadTimeOut);

        //                     if (this._isMounted) {
        //                         this.setState({
        //                             stopBtnStatus: false,
        //                             uploadingStatus: true,
        //                         });
        //                     }

        //                     this._t.disable();
        //                     this._t.stop();
        //                     this._t.upload();
        //                 } catch (e) {
        //                     console.error(e);
        //                 }

        //             } else {
        //                 try {
        //                     clearTimeout(autoUploadTimeOut);

        //                     if (this._isMounted) {
        //                         this.setState({
        //                             stopBtnStatus: false,
        //                             uploadingStatus: true,
        //                         });
        //                     }

        //                     this._t.disable();
        //                     this._t.stop();
        //                     this._t.upload();
        //                 } catch (e) {
        //                     console.error(e);
        //                 }
        //             }
        //         }
        //     }).catch();
    }

    stop = () => {
        try {
            this.setState({
                uploadBtnStatus: false,
                stopBtnStatus: true,
                uploadingStatus: false,
            });
            this._t.enable();
            this._t.stop();
        } catch (e) {
            console.error(e);
        }
    }

    checkLen = () => {
        let count = 0;
        if (this._t) {
            for (let key in this._t.uploadInfo) {
                count = count + 1;
            }
            if (this._t.uploading) {
                return count;
            }
        }
        return 0;
    }

    getCFlen = () => {
        let len = 0;
        if (this._t) {
            len = this._t.waiting.length;
        }
        return len;
    }

    afterError = (status, msgJson) => {
        let message = msgJson.message.toString();
        let callBack = this.props.callBack;
        let fileList = this.state.fileList;
        let state = "";
        if (typeof (callBack) === "function") {
            callBack();
        } else if (typeof (callBack) === "string") {
            eval(callBack);
        }
        if (Object.is(message, "typeError")) { // 图片类型错误
            state = -7;
        } else if (Object.is(message, "senseError")) { // 图片分辨率太高
            state = -10;
        } else { // 其他错误
            state = -3;
        }
        for (let item of fileList) {
            if (item.state === -1 || item.state === -2) {
                item.state = state;
                // 列表中其他待传记录
                if (this._t.waiting.length > 0) {
                    this._t.cancelOne(item.id);
                    this._t.uploading = !0;
                    this._t.upload(this._t.waiting[0]);
                } else {
                    this._t.cancelOne(item.id);
                    this._t.enable();
                    this._t.stop();
                    this.changeBtnStatus('', true, false);
                    this.setState({
                        uploadingStatus: false,
                    });
                }
                break;
            }
        }
    }

    /** 关闭模态窗前 判断如果存在文件 则清空 */
    uploadModelClose = () => {
        let { close } = this.props;
        // 正在上传
        let checkLen = this.checkLen();
        // 等待上传个数
        let cflen = this.getCFlen();
        if (checkLen === 0 && cflen === 0) {
            close && close();
        } else {
            Modal.confirm({
                title: window.language['material.notice'],
                okText: window.language['common.ok'],
                cancelText: window.language['common.cancel'],
                className: 'custom-modal',
                content: window.language['material.upload.isClose'],
                onOk: () => {
                    this.removeMethod();
                    close && close();
                },
                onCancel: () => { },
            });
        }
    }

    /** 切换是否自动上传 */
    changeIsAuto = (isAuto) => {
        if (!isAuto) {
            clearTimeout(autoUploadTimeOut);
        } else {
            autoUploadTimeOut = setTimeout(() => {
                if (this._isMounted) {
                    this.setState({
                        uploadingStatus: true,
                        stopBtnStatus: false,
                    });
                }
                // this._t.upload();
                this.upload();
            }, 3000);
        }
        $$.setStore(`${username}_IsAutoUpload`, isAuto);
        this.setState({
            isAuto
        });
    }

    /** 获取上传图标信息、提示信息、进度条状态 */
    getUploadFileState = (state) => {
        let result = { iconMsg: '', tipMsg: '', classStyle: '', progressStatus: '' };
        switch (state) {
            case -1:
                // 等待上传中...
                result['iconMsg'] = 'material-upload-wait';
                result['tipMsg'] = window.language['material.wait'];
                result['progressStatus'] = 'normal';
                result['classStyle'] = 'load-font-color';
                break;
            case -2:
                // 上传中...
                result['iconMsg'] = 'material-upload-wait';
                result['tipMsg'] = window.language['material.uploading'];
                result['progressStatus'] = 'active';
                result['classStyle'] = 'percent-font-color';
                break;
            case -3:
                // 上传失败
                result['iconMsg'] = 'material-upload-error';
                result['tipMsg'] = window.language['material.uploadFailed'];
                result['progressStatus'] = 'exception';
                result['classStyle'] = 'fail-font-color';
                break;
            case -4:
                // 上传成功
                result['iconMsg'] = 'material-upload-ok';
                result['progressStatus'] = 'success';
                break;
            case -5:
                // 取消上传
                result['iconMsg'] = 'material-upload-wait';
                result['tipMsg'] = window.language['material.cancel'];
                result['progressStatus'] = 'normal';
                result['classStyle'] = 'load-font-color';
                break;
            case -7:
                // 类型错误
                result['iconMsg'] = 'material-upload-error';
                result['tipMsg'] = window.language['material.typeError'];
                result['progressStatus'] = 'exception';
                result['classStyle'] = 'fail-font-color';
                break;
            case -8:
                // 内容不正确
                result['iconMsg'] = 'material-upload-error';
                result['tipMsg'] = window.language['material.contentError'];
                result['progressStatus'] = 'exception';
                result['classStyle'] = 'fail-font-color';
                break;
            case -9:
                // 已存在
                result['iconMsg'] = 'material-upload-error';
                result['tipMsg'] = window.language['material.existError'];
                result['progressStatus'] = 'exception';
                result['classStyle'] = 'fail-font-color';
                break;
            case -10:
                // 图片分辨率太高
                result['iconMsg'] = 'material-upload-error';
                result['tipMsg'] = window.language['material.senseError'];
                result['progressStatus'] = 'exception';
                result['classStyle'] = 'fail-font-color';
                break;
            default:
                result['progressStatus'] = 'normal';
        }
        return result;
    }

    /** 统计上传的个数 */
    setMaterialCount = (fileName) => {
        if (!fileName || fileName.length < 0) {
            return;
        }
        let { fileCount: { pictureCount, videoCount, musicCount, wordCount, excelCount, pdfCount, pptCount, sysCount } } = this.state;
        let suffix = fileName.substring(fileName.lastIndexOf("."), fileName.length).toLowerCase();
        if (picExtFilters.indexOf(suffix) !== -1) {
            pictureCount++;
        } else if (videoExtFilters.indexOf(suffix) !== -1) {
            videoCount++;
        } else if (musicExtFilters.indexOf(suffix) !== -1) {
            musicCount++;
        } else if (wordExtFilters.indexOf(suffix) !== -1) {
            wordCount++
        } else if (excelExtFilters.indexOf(suffix) !== -1) {
            excelCount++;
        } else if (pptExtFilters.indexOf(suffix) !== -1) {
            pptCount++;
        } else if (pdfExtFilters.indexOf(suffix) !== -1) {
            pdfCount++;
        } else if (sysExtFilters.indexOf(suffix) !== -1) {
            sysCount++;
        }
        return { pictureCount, videoCount, musicCount, wordCount, excelCount, pdfCount, pptCount, sysCount }
    }

    render() {
        let { currentType, type, tips, uploadFolderTipMsg = window.language['material.upload.tipMsg'] } = this.props;
        let { stopBtnStatus, uploadBtnStatus, uploadingStatus, isAuto, fileList, fileCount } = this.state;
        let uploadParam = null;
        let siderNode = null;
        let uploadShowStyle = {};
        let disShow = {};
        if (fileList && fileList.length > 0) {
            uploadParam = fileList.map((item, index) => {
                let percent = item.percent;
                let state = item.state;
                let param = this.getUploadFileState(state);
                let src = 'assets/images/material/' + param.iconMsg + '.png';
                return (
                    <div key={index}>
                        <ul className="upload-file-ul">
                            <li className="upload-li-icon" style={{ width: '30px' }}>
                                <Img className="material-convert-rotation" src={src} />
                            </li>
                            <li style={{ width: '170px', paddingRight: '15px' }} className="text-ellipsis">{item.name}</li>
                            <li style={{ width: '125px' }} className={param.classStyle}>
                                {state === -2 ? `${percent}%` : param.tipMsg}
                            </li>
                            <li style={{ width: '60px' }} className={uploadingStatus ? 'upload-oper-disable' : 'upload-oper-li'}>
                                <span onClick={(e) => this.remove(item)}>{window.language['material.delete']}</span>
                            </li>
                        </ul>
                        <div className="upload-progress">
                            <Progress percent={percent} status={param.progressStatus} />
                        </div>
                    </div>
                );
            });
        } else {
            uploadShowStyle = { width: '824px' };
            disShow = { display: 'none' };
        }

        if (type && type.length > 0) {
            let badgeNode = type.map((t, index) => {
                let iconName = "";
                let count = "";
                if (t === '1') {
                    iconName = "material-picture-o";
                    count = fileCount.pictureCount;
                } else if (t === '0') {
                    iconName = "material-video-o";
                    count = fileCount.videoCount;
                } else if (t === '2') {
                    iconName = "material-music-o";
                    count = fileCount.musicCount;
                } else if (t === '15') {
                    iconName = "material-word-o";
                    count = fileCount.wordCount;
                } else if (t === '16') {
                    iconName = "material-excel-o";
                    count = fileCount.excelCount;
                } else if (t === '17') {
                    iconName = "material-ppt-o";
                    count = fileCount.pptCount;
                } else if (t === '35') {
                    iconName = "material-pdf-o";
                    count = fileCount.pdfCount;
                } else if (t === '10') {
                    iconName = "menu-setting-o";
                    count = fileCount.sysCount;
                } else if (t === '19') {
                    iconName = "material-excel-o";
                    count = fileCount.excelCount;
                } else {
                    return "";
                }
                iconName += currentType === t ? ' selected' : ''
                return (
                    <div key={index} className="upload-lefticon">
                        <Badge count={count}>
                            <Icon className={iconName} title="" />
                        </Badge>
                    </div>
                )
            });
            siderNode = (
                <Sider width={54} className="material-upload-left">
                    {badgeNode}
                    {tips ? (
                        <div className="upload-lefticon">
                            <Popover content={tips} >
                                <Icon className="question-o upload-tip-style" />
                            </Popover>
                        </div>
                    ) : null}
                </Sider>
            )
        }

        return (
            <Layout className="upload-layout">
                {siderNode}
                <Layout className="material-upload-body">
                    <div className="upload-bodydiv">
                        <div id="i_stream_dropzone" className="upload-bodyleft" style={uploadShowStyle}>
                            <div id="i_select_files" className="upload-add-file">
                                <div className="add-01"></div>
                                <div className="add-02"></div>
                                <div className="add-03"></div>
                            </div>
                            <p className="upload-left-font1">{window.language['material.dragAndDropTips']}</p>
                            <p className="upload-left-font2">{uploadFolderTipMsg}</p>
                        </div>
                        <div className="upload-bodyright" style={disShow}>
                            <div className="upload-top-btn">
                                <ul className="tool-icon-button">
                                    <li className={uploadBtnStatus ? 'tool-icon-gray-button' : 'tool-icon-default-button'}
                                        onClick={() => { this.upload() }}>
                                        <Icon className="upload" /><span>{window.language['common.upload']}</span>
                                    </li>
                                    <li className={stopBtnStatus ? 'tool-icon-gray-button' : 'tool-icon-default-button'}
                                        onClick={() => { this.stop() }}
                                    >
                                        <Icon className="upload-pause" /><span>{window.language['material.upload.pause']}</span>
                                    </li>
                                </ul>
                                <Checkbox className="upload-auto-button" checked={isAuto} onChange={(e) => { this.changeIsAuto(e.target.checked) }}>
                                    {window.language['material.autoUpload']}
                                </Checkbox>
                            </div>
                            <div className="upload-file-list">
                                {uploadParam}
                            </div>
                        </div>
                    </div>
                </Layout>
            </Layout>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Upload/UploadPanel.js